export const openManageSubscription = payload => ({
  type: 'OPEN_MANAGE_SUBSCRIPTION',
})

export const closeManageSubscription = payload => ({
  type: 'CLOSE_MANAGE_SUBSCRIPTION',
})
